import { useQuery } from 'react-query';

import { getFilterReferencesOptions as queryFn } from 'api/endPoints/getFilterReferencesOptions';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetFilterReferencesOptions = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getFilterReferencesOptions', params],
        queryFn: () => queryFn(params),
        enabled:
            Boolean(params.contractId) &&
            Boolean(params.metaDataId) &&
            Boolean(params.rowType) &&
            Boolean(params.filterItem),
    });
};

export interface QueryParams {
    contractId?: number;
    metaDataId?: number;
    rowType?: string;
    filterItem?: string;
    searchToken?: string | null;
    filterItemReferences?: { label: string; value: string }[];
}

export interface Activity {
    label: string;
    value: string;
    activitiesCount: number;
    brokenReferenceLink: boolean;
}

export interface QueryResponse {
    key: string;
    value: Activity[];
}
